// All posts previously hardcoded here now live in the `blogs` database table,
// managed via the admin dashboard (/admin/blogs) and served by blog-posts.php.
const Blogs = [];

export default Blogs;
